import CountUp from 'react-countup';
import '../../../css/About.css';

const FreeClass = () => {
  return (
    <section className='bg-primary'>
      <div className='mx-auto px-4 sm:px-6 container lg:px-8'>
        <div className='grid grid-cols-1 gap-5 md:grid-cols-3 lg:grid-cols-4'>
          <div className='text-center md:border-r md:border-[#c2ffd7] pt-[80px] pb-[0px] md:pt-[100px] md:pb-[100px] lg:pt-[120px] lg:pb-[120px]'>
            <h1 className='mb-3 text-4xl font-bold text-white'>
              <CountUp end={2000} duration={2.75} enableScrollSpy={true} />+
            </h1>
            <p className='text-white font-medium text-[17px] uppercase'>
              Successfull Student
            </p>
          </div>
          <div className='text-center md:border-r md:border-[#c2ffd7] pt-[40px] pb-[0px] md:pt-[100px] md:pb-[100px] lg:pt-[120px] lg:pb-[120px]'>
            <h1 className='mb-3 text-4xl font-bold text-white'>
              <CountUp end={500} duration={2.75} enableScrollSpy={true} />+
            </h1>
            <p className='text-white font-medium text-[17px] uppercase'>
              Europ Placement
            </p>
          </div>
          <div className='text-center md:border-r md:border-[#c2ffd7] pt-[40px] pb-[0px] md:pt-[100px] md:pb-[100px] lg:pt-[120px] lg:pb-[120px]'>
            <h1 className='mb-3 text-4xl font-bold text-white'>
              <CountUp end={100} duration={2.75} enableScrollSpy={true} />%
            </h1>
            <p className='text-white font-medium text-[17px] uppercase'>
              Success Rate
            </p>
          </div>
          <div className='text-center  pt-[40px] pb-[80px] md:pt-[100px] md:pb-[100px] lg:pt-[120px] lg:pb-[120px]'>
            <h1 className='mb-3 text-4xl font-bold text-white'>
              <CountUp end={10} duration={2.75} enableScrollSpy={true} />+
            </h1>
            <p className='text-white font-medium text-[17px] uppercase'>
              Years Experience
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeClass;
